import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'

export const api = {
  getInvoiceHeadList: ipConfig.api_mwclg + '/mcp/nc/getInvoiceHeadList', // 发票列表
  exportInvoiceHeadList: ipConfig.api_mwclg + '/mcp/nc/exportInvoiceHeadList', // 导出发票列表
  getInvoiceDetail: ipConfig.api_mwclg + '/mcp/nc/getInvoiceDetail', // 发票详情
  exportInvoiceDetailList: ipConfig.api_mwclg + '/mcp/nc/exportInvoiceDetailList', // 导出发票详情
  insertInvoiceQuery: ipConfig.api_mwclg + '/mcp/nc/insertInvoiceQuery' // 发票疑问反馈
}

// 发票列表
export function getInvoiceHeadList (data) {
  return axios({
    url: api.getInvoiceHeadList,
    method: 'post',
    data
  })
}

// 导出发票列表
export function exportInvoiceHeadList (data) {
  return axios({
    url: api.exportInvoiceHeadList,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 发票详情
export function getInvoiceDetail (params) {
  return axios({
    url: api.getInvoiceDetail,
    method: 'get',
    params
  })
}

// 导出发票详情
export function exportInvoiceDetailList (params) {
  return axios({
    url: api.exportInvoiceDetailList,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 发票疑问反馈
export function insertInvoiceQuery (data) {
  return axios({
    url: api.insertInvoiceQuery,
    method: 'post',
    data
  })
}
